import React from 'react'
import { Field, Form } from 'react-final-form'

import { Primary as Button } from '@cinch/oxd-components/button/src'

import * as styles from './search-form.module.css'
import { TextFieldWrapper } from '@cinch/oxd-components/final-form-wrappers/src'

const SearchForm: React.FC<{ onSubmit: any; initialValues?: object }> = ({ onSubmit, initialValues = {} }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, pristine, submitting }) => (
        <form name="jargon-search" onSubmit={handleSubmit} className={styles.form}>
          <Field
            id="searchInput"
            name="search"
            type="search"
            component={TextFieldWrapper}
            oxford={true}
            label="I want to understand"
            autoComplete="off"
            placeholder="e.g. Car Insurance"
            fullWidth={true}
          />

          <Button
            oxdClassName={styles.button}
            type="submit"
            disabled={pristine}
            isLoading={submitting}
            size={'large'}
            oxford={true}
          >
            Search
          </Button>
        </form>
      )}
    />
  )
}

export default SearchForm
